import React from 'react';
import _classNames from 'classnames';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles(theme => ({
  formContainer: {
    paddingLeft: '3%',
    paddingRight: '3%',
    background: '#F3FBFF',
    position: 'relative',
    overflow: 'hidden',
    '&:before': {
      content: '""',
      pointerEvents: 'none',
      background: 'linear-gradient(178deg, #93D1F5 0%, #EEF8FE 100%)',
      position: 'absolute',
      right: 0,
      width: 200,
      height: 400,
      opacity: '0.2',
      transform: 'scaleY(-1) rotate(13deg)',
      borderRadius: '100% 0% 0% 0% / 100% 0% 0% 0%',
    },
    '&:after': {
      content: '""',
      pointerEvents: 'none',
      position: 'absolute',
      left: 0,
      bottom: 0,
      width: 250,
      height: 630,
      opacity: '0.2',
      transform: 'scaleY(-1) rotate(0deg)',
      background: 'linear-gradient(138.38deg, #93D1F5 0%, #EEF8FE 100%)',
      borderRadius: '0% 80% 80% 0 / 0% 50% 50% 0%',
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: '100vh',
      background: '#fff',
      '&:before': {
        display: 'none',
      },
      '&:after': {
        display: 'none',
      },
    },
  },
  clientFormContainer: {
    paddingTop: 40,
  },
}));

const FormContainer = ({ children }) => {
  const [authImageSiteCopy] = useSiteCopySelector([
    'authentication-pages-image',
  ]);
  const classes = useStyles({
    background: _get(authImageSiteCopy, 'pageCopy.mobile-background.1x'),
    background2x: _get(authImageSiteCopy, 'pageCopy.mobile-background.2x'),
  });
  const clientDetails = useSelector(makeSelectClientDetails());
  const hasClient = !_isEmpty(clientDetails);

  return (
    <Grid
      item
      xs={12}
      md={7}
      className={_classNames(classes.formContainer, {
        [classes.clientFormContainer]: hasClient,
      })}
    >
      {children}
    </Grid>
  );
};

FormContainer.propTypes = {
  children: PropTypes.node,
};

export default FormContainer;
